import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Stato vuoto / placeholder coerente. Usato per pagine non ancora implementate
 * o per liste vuote. Stile minimal Apple: spazio generoso, icona discreta. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "rounded-lg border border-dashed bg-card/40 px-6 py-16 flex flex-col items-center text-center",
        className
      )}
    >
      {Icon && (
        <div className="size-12 rounded-full bg-brand-50 text-brand-700 grid place-items-center mb-5">
          <Icon className="size-5" />
        </div>
      )}
      <h2 className="text-base font-medium text-foreground">{title}</h2>
      {description && (
        <p className="mt-2 max-w-md text-sm text-muted-foreground leading-relaxed">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
